// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CreateSequenceNumberRequestModel from '../../model/create-sequence-number-request-model';
import CreateSequenceNumberRequestDTO from '../dto/create-sequence-number-request-dto';

export default abstract class CreateSequenceNumberRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CreateSequenceNumberRequestDTO>) {
    super();
    if (data) {
      this.name = data.name;
      this.startNumber = data.startNumber;
      this.increment = data.increment;
    }
  }
  /**
  */
  'name'?: string;
  /**
  * @type {int32}
  */
  'startNumber'?: number;
  /**
  * @type {int32}
  */
  'increment'?: number;

  static toModel(dto: DeepPartial<CreateSequenceNumberRequestDTO>): CreateSequenceNumberRequestModel;
  static toModel(dto: DeepPartial<CreateSequenceNumberRequestDTO> | undefined | null): CreateSequenceNumberRequestModel | undefined;
  static toModel(dto: DeepPartial<CreateSequenceNumberRequestDTO> | undefined | null): CreateSequenceNumberRequestModel | undefined {
    return dto ? new CreateSequenceNumberRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CreateSequenceNumberRequestModel> | CreateSequenceNumberRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'name': unwrapped.name,
      'startNumber': unwrapped.startNumber,
      'increment': unwrapped.increment,
    } as CreateSequenceNumberRequestDTO;
  }
}
